// extracted by mini-css-extract-plugin
export var chip = "_dg-0";
export var filterDropdown = "_dg-5";
export var filterItem = "_dg-6";
export var icon = "_dg-1";
export var removeButton = "_dg-3";
export var removeIcon = "_dg-4";
export var separator = "_dg-2";